export const de = {
  languages: {
    english: "Englisch",
    spanish: "Spanisch",
    dutch: "Niederländisch",
    french: "Französisch",
    portuguese: "Portugiesisch",
    italian: "Italienisch",
    german: "Deutsch",
    polish: "Polnisch",
    romanian: "Rumänisch",
    greek: "Griechisch",
    //TODO: add new language here
  },
  loginPage: {
    title: "Anmelden",
    email: "E-Mail",
    placeholder: "Geben Sie Ihre E-Mail-Adresse ein",
    buttonText: "Anmelden",
    loginMessage:
      "Eine E-Mail wurde an die angegebene E-Mail-Adresse gesendet. Bitte klicken Sie auf den Link in der E-Mail, um sich zu authentifizieren.",
    noEmailMessage:
      "Bitte verwenden Sie den Link in der E-Mail, die Ihnen zugesandt wurde, um diesen Vorgang zu starten.",
  },
  formPage: {
    title: "Periodische Überprüfung",
    submittedMessage: "Das Formular wurde übermittelt!",
    alreadySubmittedMessage:
      "Das Formular wurde bereits übermittelt! Wenn Sie zuvor übermittelte Informationen ändern möchten, wenden Sie sich bitte an Ihren Kundenbetreuer.",
    waitMessage: "Daten werden geladen, bitte warten...",
    asteriskMessage1: "Bitte füllen Sie alle Felder mit",
    asteriskMessage2: "aus, da diese erforderlich sind.",
    savedLocallyMessage:
      "Alle Änderungen werden lokal auf Ihrem Gerät gespeichert.",
    accessFormAgain: "Sie können das Formular über den Link erneut aufrufen",
    openPRs: "Offene periodische Überprüfungen",
    addRelation: "Beziehung hinzufügen",
    submit: "Senden",
    continue: "Weiter",
    addFile: "Datei hinzufügen",
  },
};
